module.exports = __webpack_public_path__ + "static/media/Gallery_Slider_4-min.feab2884.jpg";